import { Component, OnInit } from "@angular/core";
import { Platform, ModalController, IonicModule } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { AppSettings } from "../../../app/appSettings";
import { ContentProvider } from "../../../providers/content-provider/content-provider";
import { Router } from "@angular/router";


@Component({
  templateUrl: "cookiemodal.html",
  standalone: true,
  selector: 'cookiemodal',
  styleUrls: ['cookiemodal.scss'],
  imports: [IonicModule]
})
export class CookieModalPage implements OnInit {
  DEBUG = AppSettings.DEBUG;
  TAG = "CookieModal";

  data;
  title;
  accept;
  decline;
  text;
  text2
  privacy;

  constructor(
    public platform: Platform,
    public transl: TranslateService,
    public viewCtrl: ModalController,
    public router: Router,
    public cp: ContentProvider,
  ) {
    
  }


  ngOnInit(): void {
    if (this.DEBUG) console.log(this.TAG);
  }

  ionViewDidEnter() {
    if (this.DEBUG) console.log(this.TAG, "TestionViewDidEnter");
  }

  submitConsent($event): void {
    if (this.DEBUG) console.log(this.TAG, "TestsubmitConsent ", $event);
    
    this.dismiss(this.data);
  }

  public dismiss(data) {
    if (this.DEBUG) console.log(this.TAG, "Testdismiss", data);
    this.viewCtrl.dismiss(data);
  }


}
